import React from 'react';
import { withRouter } from 'react-router-dom';
import Settings from './Settings';

const SettingsContainer = () => (
      <Settings />
);

export default withRouter(SettingsContainer);